import { useState, useCallback } from 'react';
// Ui
import Modal from 'ui3/Modal/Modal';
// Components
import VideoControlButton from 'ui/VideoPlayer/components/VideoControlButton/VideoControlButton';

import styles from './VideoSettings.module.scss';

type VideoSettingsProps = {
  settings: JSX.Element;
  onOpenChange?: (open: boolean) => void;
};

const VideoSettings = ({ settings, onOpenChange }: VideoSettingsProps) => {
  const [isModalVisible, setModalVisibility] = useState<boolean>(false);

  const handleModalToggle = useCallback(() => {
    setModalVisibility((prev) => {
      const next = !prev;
      onOpenChange?.(next);
      return next;
    });
  }, [onOpenChange]);

  const handleClose = useCallback(() => {
    setModalVisibility(false);
    onOpenChange?.(false);
  }, [onOpenChange]);

  return (
    <>
      <div className={styles.root}>
        <VideoControlButton
          icon="gear"
          title="Change video/audio recording devices"
          onClick={handleModalToggle}
        />
      </div>

      <Modal
        title="Settings"
        size="small"
        open={isModalVisible}
        onClose={handleClose}
        focusTrapped={false}
      >
        {settings}
      </Modal>
    </>
  );
};

export default VideoSettings;
